import api from './api';

export class RequerimentoService {
  gerarProtocoloAtendimento = async (matricula, token, acao) => {
    return api.post(`GerarProtocolo`, {
      matricula,
      token,
      acao,
    });
  };

  toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result.split(',')[1]);
      reader.onerror = (error) => reject(error);
    });

  requestValido = (resultadoRequest) => {
    return resultadoRequest.status === 200 && resultadoRequest.data;
  };

  obterFormulariosDisponiveis = async ({
    matricula,
    token,
    plano,
    sitpart,
    beneficio,
  }) => {
    const response = await api.get('ObterFormulariosMatricula', {
      params: { matricula, token, plano, sitpart, beneficio },
    });

    const formattedResponse = response.data.map((item) => {
      return {
        nome: item.nome,
        referencia: item.referencia,
        apelido: item.apelido,
        descricao: item.descricao,
        destino: item.navegacao,
        habilitado: item.habilitado === 'true',
      };
    });

    return formattedResponse;
  };

  obterTitulosFormularios = async () => {
    const response = await api.get('ObterFormularios');

    return response.data;
  };

  obterRequerimentosPorMatricula = async (matricula, token) => {
    const resultadoRequest = await api.get(
      `ObterRequerimentosMatricula?matricula=${matricula}&token=${token}`,
      {
        matricula,
        token,
      }
    );

    return resultadoRequest.data;
  };

  obterMedicosPeritos = async () => {
    const resultadoRequest = await api.get(
      'ObterConfiguracoesPortal?parametro=MedicoPerito'
    );

    const respostaValida =
      this.requestValido(resultadoRequest) &&
      Array.isArray(resultadoRequest.data.results);

    if (!respostaValida) return [];

    const encontrouParametro = resultadoRequest.data.results.length > 0;

    if (!encontrouParametro) return [];

    const medicos = resultadoRequest.data.results[0].Valor.split(';');
    return medicos;
  };

  persistirFormulario = async (
    matricula,
    token,
    campos,
    formulario,
    protocolo
  ) => {
    const payload = {
      token,
      campos: JSON.stringify(campos),
      matricula,
      formulario,
      protocolo,
    };

    return api.post('InsereRequerimento', payload);
  };

  // concluir move para o status 'em andamento'
  concluirRequerimento = async ({
    token,
    formulario,
    matricula,
    protocolo,
    dadoscadastrais,
  }) => {
    return api.post('ConcluirRequerimento', {
      token,
      formulario,
      matricula,
      protocolo,
      dadoscadastrais,
    });
  };

  atualizaRequerimento = async ({
    token,
    formulario,
    matricula,
    protocolo,
    campos,
  }) => {
    const payload = {
      token,
      formulario,
      matricula,
      protocolo,
      campos: JSON.stringify(campos),
    };

    return api.post('AtualizaRequerimento', payload);
  };

  persistirAnexo = async ({
    anexo,
    protocolo,
    matricula,
    token,
    nomearquivo,
    tipoanexo,
  }) => {
    const file = await this.toBase64(anexo);

    return api.post('UploadArquivoProtocolo', {
      anexo: file,
      protocolo,
      matricula,
      token,
      nomearquivo,
      tipoanexo,
    });
  };

  obterRequerimento = async ({ protocolo, matricula, token }) => {
    return api.get(`ObterRequerimento`, {
      params: {
        protocolo,
        matricula,
        token,
      },
    });
  };

  obterStatusRequerimento = async ({ matricula, token, status }) => {
    return api.get('ObterRequerimentosMatriculaStatus', {
      params: {
        matricula,
        token,
        status,
      },
    });
  };

  indeferirRequerimento = ({ token, formulario, matricula, protocolo }) => {
    return api.post(`IndeferirRequerimento`, {
      token,
      formulario,
      matricula,
      protocolo,
    });
  };

  obterAnexosPendentesPorProtocolo = ({ protocolo, matricula, token }) => {
    return api.get('ObterAnexosIndeferidosProtocolo', {
      params: {
        protocolo,
        matricula,
        token,
      },
    });
  };

  obterTermoJudicial = async () => {
    try {
      const response = await api.get('ObterTermoJudicial');

      return response.data.results[0].URL;
    } catch (e) {
      return '';
    }
  };

  obterTermoInfoMedicaComplementares = async () => {
    try {
      const response = await api.get('ObterFormulariosPlanoImposto');

      return response.data.results[0].URL;
    } catch (e) {
      return '';
    }
  };

  obterTermoRevisao = async () => {
    try {
      const response = await api.get('ObterTermoRevisao');

      return response.data.results[0].URL;
    } catch (e) {
      return '';
    }
  };

  gerarPDFRequerimento = async (params) => {
    try {
      const response = await api.get('GerarPDFRequerimento', {
        params,
        responseType: 'arraybuffer',
      });

      return response.data;
    } catch (error) {
      return null;
    }
  };
}
